import styles from "./PresaleExchangeDone.module.scss";
import { PUBLIC_ICON, PUBLIC_IMAGE } from "../../../constants";
import presaleStore from "../../../stores/presaleStore";
import MyButton from "../../../components/UI/MyButton/MyButton";
import { useNavigate } from "react-router";
import {
  ACCOUNT_ROUTE,
  PRESALE_EXCHANGE_ROUTE,
  PRESALE_ROUTE,
  PROFILE_ROUTE,
} from "../../../utils/consts";
import { useContext, useEffect, useState } from "react";
import { check } from "../../../http/userAPI";
import { observer } from "mobx-react-lite";
import { Context } from "../../../..";
import MySpinner from "../../../components/UI/MySpinner/MySpinner";
import { Helmet } from "react-helmet";

const PresaleExchangeDone = () => {
  const { user } = useContext(Context);
  const [isExchanged, setIsExchanged] = useState(false);
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const navigate = useNavigate();

  useEffect(() => {
    const endTime =
      new Date(presaleStore.buyInfo?.timestamp).getTime() + 15 * 60 * 1000;
    const interval = setInterval(() => {
      const now = Date.now();
      const diff = endTime - now;

      if (diff <= 0) {
        setTimeLeft(0);
        clearInterval(interval);
      } else {
        setTimeLeft(diff);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [presaleStore.buyInfo?.timestamp]);

  const formatTime = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const handleStatusCheck = async () => {
    try {
      const res = await fetch(
        "/api/v1/presale/check_exchange",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: presaleStore.buyInfo.id }),
        }
      );

      if (!res.ok) {
        throw new Error(`Ошибка сервера: ${res.status}`);
      }

      const result = await res.json();

      if (result.is_exchanged == "yes") {
        setIsExchanged(true);
        presaleStore.setClickBuy(false);
        presaleStore.setResult("0", 0, 0);
      }
    } catch {
      console.error("Ошибка при выполнении fetch-запроса checkPayd:");
    }
  };

  useEffect(() => {
    if (isExchanged) return;

    const intervalId = setInterval(() => {
      handleStatusCheck();
    }, 30000);

    return () => clearInterval(intervalId);
  }, [isExchanged]);

  const handleButtonProfile = () => {
    navigate(PROFILE_ROUTE);
  };

  const getFormattedDate = (dateString: string): string => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    const formatter = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZone: "UTC",
    });

    return formatter.format(date);
  };

  return (
    <>
      <Helmet>
        <title>Profile</title>
        <link rel="icon" href={PUBLIC_ICON + "Alfa.svg"} />
      </Helmet>
      <div className={styles.modal__windowMainWrapper}>
        <div className={styles.modal__window}>
          <img className={styles.modal__widowClose}></img>
          <div className={styles.modal__windowTimer}>
            {formatTime(timeLeft)}
          </div>
          <div className={styles.modal__windowWrapper}>
            <div className={styles.modal__howToPlay}></div>
            <div className={styles.modal__canceled}></div>
            <div className={styles.modal__application}>
              Please note that the rate is fixed after 12 network confirmations.
              Attention! Your transaction will be checked according to the AML
              Policy of the exchange office.
            </div>
            <div className={styles.modal__amount}>
              <div className={styles.amount__text}>
                <div className={styles.amount__textWeaving}>Sent</div>
                <div className={styles.amount__textReceived}>Received</div>
                <div className={styles.amount__textReceipt}>
                  Transaction ID{" "}
                </div>
              </div>
              <div className={styles.amount__value}>
                <div className={styles.amount__valueWeaving}>
                  <div className={styles.amount__valueWeaving}>
                    {user.isLoading ? (
                      <MySpinner />
                    ) : (
                      `${presaleStore.buyInfo?.crypto_count} ${
                        ["TRC20", "ERC20"].includes(
                          presaleStore.buyInfo?.name ?? ""
                        )
                          ? `USDT ${presaleStore.buyInfo?.name}`
                          : presaleStore.buyInfo?.name
                      }`
                    )}
                  </div>
                </div>
                <div className={styles.amount__valueReceived}>
                  {presaleStore.buyInfo?.alfa_count} Alfa
                </div>
                <div className={styles.amount__valueReceipt}>
                  {presaleStore.buyInfo?.id}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.modal__timeStatus}>
            <div className={styles.timestatus__wrapper}>
              <div className={styles.timestatus__timeText}>Creation time</div>
              <div className={styles.timestatus__dateTime}>
                {getFormattedDate(presaleStore.buyInfo?.timestamp)}
              </div>
            </div>
            <div className={styles.timestatus__line}></div>
            <div className={styles.timestatus__wrapper}>
              <div className={styles.timestatus__statusText}>
                Application status
              </div>
              <div
                className={`${
                  isExchanged
                    ? styles.timestatus__dateTimeCanceledDone
                    : styles.timestatus__dateTimeCanceled
                }`}
              >
                In proccess
              </div>
              <div
                className={`${
                  isExchanged
                    ? styles.timestatus__ExchangeDone
                    : styles.timestatus__ExchangeDefault
                }`}
              >
                Done
              </div>
            </div>
          </div>
          <div
            className={`${
              isExchanged ? styles.wallet__imagesDone : styles.wallet__images
            }`}
          >
            <img
              src={PUBLIC_IMAGE + "modalWalletLeft.svg"}
              alt="left wallet"
              className={styles.wallet__imagesLeft}
            />
            <div
              className={`${isExchanged ? styles.loaderDone : styles.loader}`}
            >
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
            </div>
            <img
              src={PUBLIC_IMAGE + "modalWalletRight.svg"}
              alt="right wallet"
            />
          </div>
          <div
            className={
              isExchanged
                ? styles.modal__windowButton
                : styles.modal__windowButtonNone
            }
          >
            <MyButton onClick={handleButtonProfile}>Go to profile</MyButton>
          </div>
          {/* <div className={styles.modal__attention}>
        Attention! Click on the "Refresh page" button if you want to activate
        the automatic page update. The page will be updated every 30 seconds
      </div>
      <button className={styles.modal__buttonRefresh} onClick={handleReload}>
        Refresh page
      </button> */}
          <div className={styles.modal__bottomLine}></div>
        </div>
      </div>
    </>
  );
};

export default observer(PresaleExchangeDone);
